import { OrderShipment } from "../../../models";
import { MediaType, OrderType } from "../../../models/enums";

export class OrderShipmentCount {
  adebsCVD: number;
  adebsHardDrive: number;
  adebsElectronic: number;
  streamingElectronic: number;
  streamingHardDrive: number;
  cinelinkElectronic: number;
  cinelinkHardDrive: number;

  constructor(orders: OrderShipment[]) {
    this.adebsCVD = orders.filter(o => o.orderType === OrderType.Adebs && o.mediaType === MediaType.Cvd).length;
    this.adebsHardDrive = orders.filter(o => o.orderType === OrderType.Adebs && o.mediaType === MediaType.HardDrive).length;
    this.adebsElectronic = orders.filter(o => o.orderType === OrderType.Adebs && (o.mediaType === MediaType.Electronic || o.mediaType === MediaType.NetworkDelivery)).length;

    this.streamingElectronic = orders.filter(o => o.orderType === OrderType.StreamingServer && o.mediaType === MediaType.Electronic).length;
    this.streamingHardDrive = orders.filter(o => o.orderType === OrderType.StreamingServer && o.mediaType === MediaType.HardDrive).length;

    this.cinelinkElectronic = orders.filter(o => o.orderType === OrderType.Cinelink && o.mediaType === MediaType.Electronic).length;
    this.cinelinkHardDrive = orders.filter(o => o.orderType === OrderType.Cinelink && o.mediaType === MediaType.HardDrive).length;
  }
}
